import startCase from 'lodash/startCase';
import toLower from 'lodash/toLower';

import type { MetricValues, SecondaryDimensionValues } from '@revelio/core';

import type { PrimaryFilterId } from '../../../../../filters/types/filters';

export const formatColumnName = (name: string): string => {
  if (name === name.toUpperCase() || name === name.toLowerCase()) {
    return startCase(toLower(name));
  }
  return name;
};

export const getFormattedNames = (
  primaryFilterId?: PrimaryFilterId,
  secondaryDimension?: SecondaryDimensionValues,
  metric?: MetricValues
) => {
  return {
    primary: primaryFilterId ? formatColumnName(primaryFilterId) : 'Dimension',
    secondary: secondaryDimension
      ? formatColumnName(secondaryDimension)
      : 'Secondary Dimension',
    metric: metric || 'Value',
  };
};
